import { Snapshot } from 'types/Revision';
import { AppState } from 'types/AppState';

export type ProjectData = Pick<AppState, 'revisions'> &
  Omit<Snapshot, 'projectName'> &
  Partial<Pick<AppState, 'activeTool' | 'checkoutModal' | 'downloading'>>;

export const isProjectData = (
  data: Omit<ProjectFileBase, 'name' | 'src' | 'date' | 'id' | 'version'>
): data is ProjectData => {
  return (
    'scenes' in data &&
    'effects' in data &&
    'audio' in data &&
    'ratioFormat' in data &&
    'sceneVolume' in data
  );
};

export type ProjectFileBase = {
  name: Snapshot['projectName'];
  src: string;
  date: number;
  id: string;
  version?: number;
} & Partial<Omit<ProjectData, 'projectName'>>;

export type StoredProjectFiles = {
  current: string;
  list: ProjectFileBase[];
  status: 'saved' | 'saving';
};

export type Migration = (oldState: any, oldProjectFile: any) => Promise<any>;
